
export const setCurrentPage = ({ commit }, str ) => {
  if (typeof str === 'string') {
    commit('CURRENT_PAGE', str)
  }
}